import { usePageTitle } from '@/hooks/usePageTitle';
import { createFileRoute } from '@tanstack/react-router'
import { ContinuousPaymentPortoutRequestHistory } from '@/features/dashboard/continuous-payment-portout-request/history/ContinuousPaymentPortoutRequestHistory';

export const Route = createFileRoute('/_dashboard/continuous-payment-portout-requests/')({
  component: RouteComponent,
})

function RouteComponent() {
  usePageTitle("継続課金者転出依頼");
  return <ContinuousPaymentPortoutRequestHistory />
}
